
export const AUTHENTICATED = 'AUTHENTICATED'